// 20.1.2.3 Number.isInteger(number)
var $export = require(32);

$export($export.S, 'Number', {isInteger: require(48)});